import React from 'react';
import { motion } from 'framer-motion';
import { Frown, ThermometerSnowflake, BookX, Trash2, HelpCircle } from 'lucide-react';
const painPoints = [{
  icon: ThermometerSnowflake,
  text: 'Masas que no fermentan bien o se quedan planas.'
}, {
  icon: Frown,
  text: 'Panes duros, secos o apelmazados al día siguiente.'
}, {
  icon: BookX,
  text: 'Recetas mal explicadas que asumen que ya eres experto.'
}, {
  icon: Trash2,
  text: 'Ingredientes costosos desperdiciados en intentos fallidos.'
}, {
  icon: HelpCircle,
  text: "Frustración por no entender el 'por qué' del proceso."
}];
export function PainPoints() {
  return <section className="py-24 relative bg-espresso text-cream overflow-hidden" data-id="element-188">
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-189">
        <img src="https://images.unsplash.com/photo-1517686469429-8bdb88b9f907?w=1400&q=80" alt="Harina espolvoreada sobre masa de pan" className="w-full h-full object-cover" data-id="element-190" />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-192">
          <h2 className="text-4xl md:text-5xl font-bold mb-16" data-id="element-193">
            ¿Te ha pasado esto?
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-8 text-left" data-id="element-194">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`flex items-start gap-4 ${index === painPoints.length - 1 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto' : ''}`} data-id="element-195">
              <div className="mt-1 p-2 bg-terracotta/20 text-terracotta rounded-none" data-id="element-196">
                <point.icon size={24} strokeWidth={1.5} data-id="element-197" />
              </div>
              <p className="text-lg text-cream/90 leading-relaxed" data-id="element-198">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}